import { call, put, takeEvery } from "redux-saga/effects";
import * as types from "../../actionTypes";
import { toast } from "react-toastify";
import _ from "lodash";
import { loginFailed, loggedInAction } from "../../Actions/Authentication";
import { loginApi } from "./Api";
const login = function* (action) {
  try {
    const user = action.payload.user;
    const credentials = action.payload.credentials;
    if (_.has(user.attributes, 'custom:userType') && user.attributes['custom:userType'] !== "ADMIN_USER") {
      toast.error("You are not Authorized");
      yield put(loginFailed());
    } else {
      // In local mode, token is already provided from SignIn
      if (credentials?.token) {
        const userWithToken = {
          ...user,
          attributes: user.attributes,
          token: credentials.token,
          backendUser: user
        };
        yield put(loggedInAction(userWithToken));
        return;
      }

      if (!credentials?.idToken && (!credentials?.email || !credentials?.password)) {
        toast.error("Missing login credentials.");
        yield put(loginFailed());
        return;
      }
      const backendLogin = yield call(loginApi, credentials);
      if (!backendLogin?.token) {
        toast.error("Failed to obtain a session token.");
        yield put(loginFailed());
        return;
      }
      const userWithToken = {
        ...user,
        attributes: user.attributes,
        token: backendLogin.token,
        backendUser: backendLogin.user
      };
      yield put(loggedInAction(userWithToken));
    }
  } catch (err) {
    yield put(loginFailed());
    if (err.response) {
      toast.error(err.response.data.message);
    } else {
      toast.error(err?.message || err);
    }
  }
};

export function* authenticationWatcher() {
  yield takeEvery(types.LOGIN, login);
}
